import { twMerge } from "tailwind-merge";
import { ButtonProps } from ".";
import Button from "./button";
import { ReactNode } from "react";
import { useTranslations } from "use-intl";

export function SubmitButton(props: ButtonProps) {
  const { children, ...rest } = props;
  const t = useTranslations("SubmitButton");

  return (
    <Button
      htmlType="submit"
      type="primary"
      // eslint-disable-next-line react/no-children-prop
      children={children !== undefined ? children : t("Save")}
      data-testid="submit-button"
      {...rest}
    />
  );
}

export function SubmitWrapper({
  children,
  className,
  partOf,
}: {
  children: ReactNode;
  className?: string;
  partOf?: boolean;
}) {
  if (partOf) {
    return null;
  }

  return (
    <div className={twMerge("flex justify-end", className)}>{children}</div>
  );
}
